import React, { useState } from 'react';
import { LockIcon, GlobeIcon } from 'lucide-react';

import { Button } from '@epoch-ui/components/Button';
import { Modal, ModalContent, ModalHeader, ModalTitle } from '@epoch-ui/components/Modal/modal';
import {
  ActionButtonGroup,
  ActionButtonGroupItem,
  ActionButtonGroupItemIcon,
  ActionButtonGroupItemLabel,
  ActionButtonGroupItemCaption
} from '@epoch-ui/components/ActionButtonGroup';

type EventVisibility = 'public' | 'private';

interface SelectEventVisibilityModalProps extends React.ComponentProps<typeof Modal> {
  onSave: (value: EventVisibility | null) => void;
  initialValue?: EventVisibility;
}

export const SelectEventVisibilityModal = ({
  onSave,
  initialValue,
  onOpenChange,
  ...props
}: SelectEventVisibilityModalProps): React.ReactElement => {
  const [value, setValue] = useState(initialValue ?? null);

  const handleOpenChange = (open: boolean): void => {
    // Reset value when modal is closed without saving
    if (!open) {
      setValue(initialValue ?? null);
    }
    onOpenChange?.(open);
  };

  return (
    <Modal {...props} onOpenChange={handleOpenChange} modal>
      <ModalContent>
        <ModalHeader className="tw-mb-5">
          <ModalTitle>Visibility</ModalTitle>
        </ModalHeader>
        <div className="tw-flex tw-flex-col tw-gap-5">
          <ActionButtonGroup
            value={value}
            onValueChange={(v): void => setValue(v as EventVisibility | null)}
          >
            <ActionButtonGroupItem value="public">
              <ActionButtonGroupItemIcon>
                <GlobeIcon />
              </ActionButtonGroupItemIcon>
              <ActionButtonGroupItemLabel>
                Public
                <ActionButtonGroupItemCaption>
                  Anyone can see this event
                </ActionButtonGroupItemCaption>
              </ActionButtonGroupItemLabel>
            </ActionButtonGroupItem>
            <ActionButtonGroupItem value="private">
              <ActionButtonGroupItemIcon>
                <LockIcon />
              </ActionButtonGroupItemIcon>
              <ActionButtonGroupItemLabel>
                Private
                <ActionButtonGroupItemCaption>
                  Only invited guests can see this event
                </ActionButtonGroupItemCaption>
              </ActionButtonGroupItemLabel>
            </ActionButtonGroupItem>
          </ActionButtonGroup>
          <Button disabled={!value} onClick={(): void => onSave(value)}>
            Save
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};
